<template>
  <div>
    <div :class="[ {'mgmt-box': !fixHeader}, {'mgmt-box2': fixHeader}, {'mgmt-box3': getFixedHeight } ]">
      <div :class="[ 'mgmt-header', {'mgmt-header-fix': fixHeader} ]">
        <div>
          <b-dropdown id="dropdown-header" 
                      v-if="card"
                      boundary="window"
                      size="sm" 
                      :text="selectedText" 
                      v-model="selectedItem" 
                      :disabled="isDisabled"
                      class="m-1">
            <b-dropdown-header id="dropdown-header-label">
              {{ $t('Webportal.SelectYear') }}:
            </b-dropdown-header>
            <b-dropdown-item-button v-for="(option) in this.timeFrames" 
                                    :key="option"
                                    @click="selectedItem = option"
                                    aria-describedby="dropdown-header-label">
              {{ option }}
            </b-dropdown-item-button>
          </b-dropdown>
        </div>
        <div class="sub-card-title app-ctrl margin-title">
          {{ this.getFixedTitle(card.subtitle) }}
        </div>
        <div style="width: 2.5rem;">
          <b-icon v-if="card.button" 
                  icon="search" 
                  class="cx-search-icon mr-2 p-2" 
                  @click="showPopup()"
                  font-scale="1.75" />
        </div>
      </div>

      <slot :year="getYear" :selectedItem="selectedText" >
        <!-- Content -->
        <!-- {{ year }} -->
      </slot>
    </div>

    <popup  v-if="isPopupVisible"
            :title="card ? card.title : '-'"
            :popupWidth="this.getPopupWidth(card)"
            @close="hidePopup()">
      <lead-management-popup  v-if="card.title == $t('Webportal.CX.LeadManagement')"
                              :brand="brand"
                              :card="card"
                              :clientInfo="clientInfo"
                              :isJaguarMargin2023="isJaguarMargin2023"
                              :year="getYear">
                              <!-- Custom Thresholds used here -->
                              <!-- :thresholds="thresholds" -->
      </lead-management-popup>

      <margin-help-popup  v-else-if="card.title == $t('Webportal.CX.DigitalDealerPerformance')"
                          :colorRange="thresholds"/>

      <!-- Dont know when to show -->
      <InControlPopup v-else-if="card.name == 'InControl'"
                      :brand="brand"
                      :card="card"
                      :clientInfo="clientInfo"
                      :thresholds="thresholds"
                      :quarter="getQuarter"
                      :year="getYear" />

      <!-- Dont know when to show -->
      <margin-healing-popup v-else-if="false"
                            :colorRange="thresholds"/>

      <contact-quotes-popup   v-else
                              :card="card"
                              :clientInfo="clientInfo"
                              :thresholds="thresholds">
      </contact-quotes-popup>

    </popup>
  </div>
</template>

<script>
import Popup from '@/components/Shared/PopupFrame.vue';
import LeadManagementPopup from '@/components/CX/DashboardCards/LeadManagementPopup.vue';
import ContactQuotesPopup from '@/components/CX/DashboardCards/ContactQuotesPopup.vue';
import InControlPopup from '@/components/CX/DashboardCards/InControlPopup.vue';
import MarginHealingPopup from "@/components/CX/DashboardCards/MarginHealingPopup.vue";
import MarginHelpPopup from "@/components/CX/DashboardCards/MarginHelpPopup.vue";
import MarginKpiPopup from "@/components/CX/MarginKpiPopup.vue";

export default {
  components: {
    ContactQuotesPopup, InControlPopup, LeadManagementPopup, 
    MarginHealingPopup, MarginHelpPopup, MarginKpiPopup, Popup
  },

  props: {
    brand:              { type: String, required: false },
    card:               { type: Object, required: true, default: undefined },
    clientInfo:         { type: Object, default: undefined },
    clientLocationId:   { type: Number, default: undefined },
    fixHeader:          { type: Boolean, default: false },
    // year: 2023..2021; quarter: Q2/2023..Q1/2021
    selectionMode:      { type: String, default: 'year' },
    thresholds:         { type: Array, required: true }
  },

  data() {
    return {
      isPopupVisible: false,
      year: Math.max(...this.card.availableYears),
      
      items: [],
      selectedItem: this.initSelectedItem()
    }
  },
  
  mounted() {
    window.addEventListener('keyup', this.handleKeyUp);
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyUp);
  },

  computed: {
    getFixedHeight() {
      return this.fixHeader && this.card && this.card.button;
    },
    selectedText() {
      return `${this.selectedItem}`;
    },

    getYear() {
      if (this.selectionMode === 'year')
        return Number(this.selectedItem);
      else
        return Number(String(this.selectedItem).substring(3));
    },

    getQuarter() {
      if (this.selectionMode === 'year')
        throw new Error("Cannot get quarter here");
      else
        return Number(String(this.selectedItem).substring(1,2));
    },

    isDisabled() {
      return this.card.availableYears && this.card.availableYears.length <= 1;
    },

    timeFrames() {
      if (this.selectionMode === 'year')
        return this.card.availableYears;
      else {
        // Used for InControl quarterly items
        return this.card.quarterly.flatMap(x => `Q${x.Quarter}/${x.Year}`);
      }
    },

    isJaguarMargin2023() {
      return  this.selectedItem >= 2023 && // year stays at actual year
              this.brand === 'Jaguar' && 
              this.card && this.card.name === 'LeadManagement';
    }
  },

  methods: {
    initSelectedItem() {
      if (this.selectionMode === 'year') {
        return Math.max(...this.card.availableYears);
      } else {
        let qq = this.card.quarterly[this.card.quarterly.length - 1];
        return qq ? `Q${qq.Quarter}/${qq.Year}` : 'N/A';
      }
    },

    getPopupWidth(card) {
      if (card.name === "InControl")
        return 1024;
      return card && card.popupWidth ? Number(card.popupWidth) : 1024;
    },

    getFixedTitle(text) {
      if (this.isJaguarMargin2023)
        return '';

      if (!text) 
        return text;
      return text.replace('Margin', this.$t('Webportal.CX.Margin'))
        .replace(this.brand, '')
        .replace(' - ', '')
        .replace(',', '.')
        .replace('1%', '1.0%');
    },

    handleKeyUp(event) {
      if (event.key == 'Escape')
        this.hidePopup();
    },

    showPopup() {
      this.isPopupVisible = true;
    },

    hidePopup() {
      this.selectedKpi = null;
      this.selectedWave = null;
      this.isPopupVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
  .sub-card-title {
    text-align: center !important;
    margin-bottom: auto;
    margin-top: auto;
  }

  .mgmt-header-fix {
    margin-bottom: 2px!important;
  }
</style>